import { SideMenuItem } from "../interfaces/config/sideMenu";
import { LayoutDashboard, Stethoscope, UserRound, Pill, Cross, BookOpen, MessageCircle, Calculator } from "lucide-react";
import { routes, screens } from "./routes";

const sideMenuItems: SideMenuItem[] = [
  {
    id: 1,
    icon: LayoutDashboard,
    label: "Dashboard",
    route: screens.dashboard,
  },
  {
    id: 2,
    icon: UserRound,
    label: "Patients",
    route: screens.patients,
  },
  {
    id: 3,
    icon: MessageCircle,
    label: "Q&A",
    route: screens.qa,
    matchChildRoutes: true
  },
  {
    id: 4,
    icon: Stethoscope,
    label: "GenioMD",
    route: routes.genioMD.list,
    matchChildRoutes: true
  },
  {
    id: 5,
    icon: Cross,
    label: "Drugs & Diseases",
    route: screens.drugsAndDiseases,
  },
  {
    id: 6,
    icon: BookOpen,
    label: 'Congresses & Medical Updates',
    route: screens.congresses,
  }
];

// Define pages that are not in the side menu but need metadata
export const additionalPages: SideMenuItem[] = [
  {
    id: 6,
    icon: UserRound,
    label: "Patient Details",
    route: screens.patientDetails,
  },
  {
    id: 6,
    icon: Calculator,
    label: "Medical Calculators",
    route: screens.medicalCalculators,
  },
];

/**
 * The array of side menu items for the application.
 * @type {SideMenuItem[]}
 */
export const sideMenu: SideMenuItem[] = sideMenuItems;
